<template>
  <div class="home">
    <PurchasingReturnList v-show="listView" @newSales="onClickNewFromList" @editSales="onClickEditFromList" :scroll="corY" ref="refreshList"/>
    <PurchasingReturnForm v-show="formView" :retur="retur" :detail="detail" @backClicked="onBackChild" @backReload="backReload" />
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'
import PurchasingReturnList from '@/components/purchasing/PurchasingReturnList.vue'
import PurchasingReturnForm from '@/components/purchasing/PurchasingReturnForm.vue'
import { getHeader, returnUrl } from '../config'
import { mapState } from 'vuex'

export default {
  name: 'PurhcasingReturn',
  components: {
    PurchasingReturnList,
    PurchasingReturnForm
  },
  data () {
    return {
      corX: 0,
      corY: 0,
      listView: true,
      formView: false,
      retur: {
        id: null,
        type: null,
        return_no: null,
        return_date: null,
        deliver_date: null,
        vendor_no: null,
        vendor: {
          id: null,
          vendor_no: null,
          type_id: null,
          name: null,
          email: null,
          phone: null,
          mobile: null,
          vat: null,
          address: null,
          city_id: null,
          state_id: null,
          postalcode: null,
          alias: null,
          company_no: null
        },
        purchasing_no: null,
        sale_no: null,
        notes: '',
        status: null,
        branch_no: null,
        company_no: null,
        lock: false,
        is_deliver: null,
        customer_no: null,
        customer: {
          id: null,
          name: null,
          customer_no: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          birthday: null,
          birthplace: null,
          twitter: null,
          facebook: null,
          instagram: null,
          card_id: null,
          level_id: null,
          company_no: null,
          area_id: null,
          rating_id: null,
          term_due_id: null
        },
        subtotal: '0',
        discount: '0',
        discount_percentage: '0',
        tax_id: null,
        tax: '0',
        total: '0',
        salesman_id: null,
        salesaman: null,
        category: null,
        ref_no: null,
        ref: {
          id: null,
          return_no: null,
          customer_no: null,
          customer: null
        },
        details: [{
          id: null,
          return_no: null,
          product_no: null,
          product_sku: null,
          serial_number: null,
          uom_id: null,
          qty: '0',
          amount: '0',
          notes: '',
          warehouse_no: null,
          branch_no: null,
          company_no: null,
          discount: '0',
          discount_percentage: '0',
          tax_id: null,
          tax: null,
          total: '0',
          return_date: null,
          cost: null,
          cost_id: null,
          penalty_amount: '0',
          subtotal: '0',
          order_no: null,
          diff_product_parent: false,
          uomList: [{
            id: null,
            name: null,
            category_id: null,
            category: null,
            type_id: null,
            ratio: null,
            active: null,
            cost: null
          }]
        }],
        purchasing: {
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          subtotal: null,
          tax_id: null,
          tax: null,
          discount: null,
          total: null,
          delivery_cost: null,
          deliver_no: null,
          status: null,
          type_id: null,
          lock: null,
          company_no: null,
          term_due_id: null,
          ext_no: null,
          sp_no: null,
          discount_percentage: null,
          schedule_payment_date: null,
          notes: '',
          deliver_date: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            product_no: null,
            product_sku: null,
            description: null,
            qty: null,
            qty_done: null,
            uom_id: null,
            price: null,
            tax_id: null,
            tax: null,
            discount: null,
            total: null,
            company_no: null,
            vendor_no: null,
            discount_percentage: null,
            subtotal: null,
            order_no: null
          }]
        },
        sale: {
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          type_id: null,
          customer_no: null,
          customer: null,
          branch_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: '0',
          status: '0',
          price_id: null,
          warehouse_no: null,
          salesman_id: null,
          lock: null,
          company_no: null,
          term_due_id: null,
          print_counter: '0',
          bstk_counter: '0',
          return_total: '0',
          faktur_no: null,
          faktur_date: null,
          notes: '',
          commission_id: null,
          sale_commission_percentage: '0',
          sale_commission_amount: '0',
          details: [{
            id: null,
            sale_no: null,
            sale_date: null,
            branch_no: null,
            product_no: null,
            product_sku: null,
            description: null,
            qty: null,
            serial_number: null,
            uom_id: null,
            price: null,
            tax_id: null,
            tax: null,
            discount: null,
            total: null,
            queue: null,
            warehouse_no: null,
            internal_code: null,
            cost: null,
            cost_id: null,
            sec_serial_number: null,
            company_no: null,
            customer_no: null,
            discount_percentage: null,
            subtotal: null,
            order_no: null
          }]
        }
      },
      detail: [{
        id: null,
        return_no: null,
        product_no: null,
        product_sku: null,
        serial_number: null,
        uom_id: null,
        qty: '0',
        amount: '0',
        notes: '',
        warehouse_no: null,
        branch_no: null,
        company_no: null,
        discount: '0',
        discount_percentage: '0',
        tax_id: null,
        tax: null,
        total: '0',
        return_date: null,
        cost: null,
        cost_id: null,
        penalty_amount: '0',
        subtotal: '0',
        diff_product_parent: false
      }]
    }
  },
  methods: {
    async backReload (id) {
      await axios.get(returnUrl + '/' + id, { headers: getHeader() })
        .then(response => {
          this.onClickEditFromList(response.data.data)
        })
        .catch(error => {
          this.$swal(
            'Error!!!',
            error.response.data.message,
            'error'
          )
        })
    },
    async onClickEditFromList (value) {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      this.retur = value
      await axios.get(returnUrl + '/' + value.id, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.detail = response.data.data.details
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
    },
    onClickNewFromList () {
      var x = window.pageXOffset
      var y = window.pageYOffset
      this.corX = x
      this.corY = y
      window.scrollTo(0, 0)
      this.listView = false
      this.formView = true
      var company = this.companyList.find(d => d.company_no === this.authUser.company_no)
      var taxid = company ? company.tax_id : null
      this.retur = {
        id: null,
        type: 'purchasing',
        return_no: null,
        return_date: new Date().toISOString(),
        deliver_date: null,
        vendor_no: null,
        vendor: {
          id: null,
          vendor_no: null,
          type_id: null,
          name: null,
          email: null,
          phone: null,
          mobile: null,
          vat: null,
          address: null,
          city_id: null,
          state_id: null,
          postalcode: null,
          alias: null,
          company_no: null
        },
        purchasing_no: null,
        sale_no: null,
        notes: '',
        status: null,
        branch_no: null,
        company_no: this.authUser.company_no,
        lock: false,
        is_deliver: null,
        customer_no: null,
        customer: {
          id: null,
          name: null,
          customer_no: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          birthday: null,
          birthplace: null,
          twitter: null,
          facebook: null,
          instagram: null,
          card_id: null,
          level_id: null,
          company_no: null,
          area_id: null,
          rating_id: null,
          term_due_id: null
        },
        subtotal: '0',
        discount: '0',
        discount_percentage: '0',
        tax_id: taxid,
        tax: '0',
        total: '0',
        salesman_id: null,
        salesaman: null,
        category: 'others',
        ref_no: null,
        ref: {
          id: null,
          return_no: null,
          customer_no: null,
          customer: null
        },
        details: [],
        purchasing: {
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          subtotal: null,
          tax_id: null,
          tax: null,
          discount: null,
          total: null,
          delivery_cost: null,
          deliver_no: null,
          status: null,
          type_id: null,
          lock: null,
          company_no: null,
          term_due_id: null,
          ext_no: null,
          sp_no: null,
          discount_percentage: null,
          schedule_payment_date: null,
          notes: '',
          deliver_date: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            product_no: null,
            product_sku: null,
            description: null,
            qty: null,
            qty_done: null,
            uom_id: null,
            price: null,
            tax_id: null,
            tax: null,
            discount: null,
            total: null,
            company_no: null,
            vendor_no: null,
            discount_percentage: null,
            subtotal: null,
            order_no: null
          }]
        },
        sale: {
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          type_id: null,
          customer_no: null,
          customer: null,
          branch_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: '0',
          status: '0',
          price_id: null,
          warehouse_no: null,
          salesman_id: null,
          lock: null,
          company_no: null,
          term_due_id: null,
          print_counter: '0',
          bstk_counter: '0',
          return_total: '0',
          faktur_no: null,
          faktur_date: null,
          notes: '',
          commission_id: null,
          sale_commission_percentage: '0',
          sale_commission_amount: '0',
          details: [{
            id: null,
            sale_no: null,
            sale_date: null,
            branch_no: null,
            product_no: null,
            product_sku: null,
            description: null,
            qty: null,
            serial_number: null,
            uom_id: null,
            price: null,
            tax_id: null,
            tax: null,
            discount: null,
            total: null,
            queue: null,
            warehouse_no: null,
            internal_code: null,
            cost: null,
            cost_id: null,
            sec_serial_number: null,
            company_no: null,
            customer_no: null,
            discount_percentage: null,
            subtotal: null,
            order_no: null
          }]
        }
      }
    },
    async onBackChild () {
      window.scrollTo(this.corX, this.corY)
      this.listView = true
      this.formView = false
      this.retur = {
        id: null,
        type: null,
        return_no: null,
        return_date: null,
        deliver_date: null,
        vendor_no: null,
        vendor: {
          id: null,
          vendor_no: null,
          type_id: null,
          name: null,
          email: null,
          phone: null,
          mobile: null,
          vat: null,
          address: null,
          city_id: null,
          state_id: null,
          postalcode: null,
          alias: null,
          company_no: null
        },
        purchasing_no: null,
        sale_no: null,
        notes: '',
        status: null,
        branch_no: null,
        company_no: null,
        lock: false,
        is_deliver: null,
        customer_no: null,
        customer: {
          id: null,
          name: null,
          customer_no: null,
          group_id: null,
          email: null,
          phone: null,
          address: null,
          city_id: null,
          state_id: null,
          identity_number: null,
          vat: null,
          birthday: null,
          birthplace: null,
          twitter: null,
          facebook: null,
          instagram: null,
          card_id: null,
          level_id: null,
          company_no: null,
          area_id: null,
          rating_id: null,
          term_due_id: null
        },
        subtotal: '0',
        discount: '0',
        discount_percentage: '0',
        tax_id: null,
        tax: '0',
        total: '0',
        salesman_id: null,
        salesaman: null,
        category: null,
        ref_no: null,
        ref: {
          id: null,
          return_no: null,
          customer_no: null,
          customer: null
        },
        details: [{
          id: null,
          return_no: null,
          product_no: null,
          product_sku: null,
          serial_number: null,
          uom_id: null,
          qty: '0',
          amount: '0',
          notes: '',
          warehouse_no: null,
          branch_no: null,
          company_no: null,
          discount: '0',
          discount_percentage: '0',
          tax_id: null,
          tax: '0',
          total: '0',
          return_date: null,
          cost: '0',
          cost_id: null,
          penalty_amount: '0',
          subtotal: '0',
          diff_product_parent: false,
          uomList: [{
            id: null,
            name: null,
            category_id: null,
            category: null,
            type_id: null,
            ratio: null,
            active: null,
            cost: null
          }]
        }],
        purchasing: {
          id: null,
          purchasing_no: null,
          purchasing_date: null,
          purchasing_due_date: null,
          ref_no: null,
          branch_no: null,
          vendor_no: null,
          subtotal: null,
          tax_id: null,
          tax: null,
          discount: null,
          total: null,
          delivery_cost: null,
          deliver_no: null,
          status: null,
          type_id: null,
          lock: false,
          company_no: null,
          term_due_id: null,
          ext_no: null,
          sp_no: null,
          discount_percentage: null,
          schedule_payment_date: null,
          notes: '',
          deliver_date: null,
          details: [{
            id: null,
            purchasing_no: null,
            purchasing_date: null,
            branch_no: null,
            product_no: null,
            product_sku: null,
            description: null,
            qty: null,
            qty_done: null,
            uom_id: null,
            price: null,
            tax_id: null,
            tax: null,
            discount: null,
            total: null,
            company_no: null,
            vendor_no: null,
            discount_percentage: null,
            subtotal: null,
            order_no: null
          }]
        },
        sale: {
          id: null,
          sale_no: null,
          sale_date: null,
          sale_due_date: null,
          type_id: null,
          customer_no: null,
          customer: null,
          branch_no: null,
          subtotal: '0',
          tax_id: null,
          tax: '0',
          discount: '0',
          total: '0',
          delivery_cost: '0',
          deliver_no: '0',
          status: '0',
          price_id: null,
          warehouse_no: null,
          salesman_id: null,
          lock: false,
          company_no: null,
          term_due_id: null,
          print_counter: '0',
          bstk_counter: '0',
          return_total: '0',
          faktur_no: null,
          faktur_date: null,
          notes: '',
          commission_id: null,
          sale_commission_percentage: '0',
          sale_commission_amount: '0',
          details: [{
            id: null,
            sale_no: null,
            sale_date: null,
            branch_no: null,
            product_no: null,
            product_sku: null,
            description: null,
            qty: null,
            serial_number: null,
            uom_id: null,
            price: null,
            tax_id: null,
            tax: null,
            discount: null,
            total: null,
            queue: null,
            warehouse_no: null,
            internal_code: null,
            cost: null,
            cost_id: null,
            sec_serial_number: null,
            company_no: null,
            customer_no: null,
            discount_percentage: null,
            subtotal: null,
            order_no: null
          }]
        }
      }
      this.$refs.refreshList.refreshList()
    },
    async editRetur (value) {
      await axios.get(returnUrl + '/' + value, { headers: getHeader() })
        .then(response => {
          this.onClickEditFromList(response.data.data)
        })
        .catch(error => {
          console.log(error.response)
        })
    }
  },
  computed: {
    ...mapState({
      authUser: state => state.users.authUser,
      taxList: state => state.taxes.taxList,
      companyList: state => state.companies.companyList
    })
  },
  mounted () {
    this.$store.dispatch('getRowTable')
    this.$store.dispatch('getProductListSelect')
    this.$store.dispatch('getWarehouseList')
    this.$store.dispatch('getTaxList')
    this.$store.dispatch('getVendorList')
    this.$store.dispatch('getStateList')
    this.$store.dispatch('getCityList')
    this.$store.dispatch('getEmployeeList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getReturList')
    var returnID = this.$route.query.id
    if (typeof returnID !== 'undefined') {
      this.editRetur(returnID)
    }
  }
}
</script>
